import { nextProjectUrl } from '@shared/constants/urls';

export const getUserProfileLink = (magicId?: string) => {
  if (magicId) {
    return nextProjectUrl.store(`/user/${magicId}`);
  }

  return;
};
